module.exports = __webpack_public_path__ + "img/ConsiliumBots.4408cdf1.svg";